export default "__VITE_ASSET__DBLKrqSf__"